import Empty from 'constants/empty';
import { createSelector } from 'reselect';
import { testTargetOffersSelector } from 'selectors/testTarget/offers/testTargetOffersSelector';

const fastShippingCopySignedInSelector = createSelector(testTargetOffersSelector, offers => offers.fastShippingCopySignedIn || Empty.Object);

export { fastShippingCopySignedInSelector };
